import { usePaymentApiV1 } from '../../clients/quipli-service/payment/payment-api-v1';
import { useEffect, useState } from 'react';
import { BankAccount } from '@stripe/stripe-js';
import { Typography } from '../../components/typography/typography';
import { Card } from '../../components/card/card';

export const BankDetails = () => {
  const { getBankDetails } = usePaymentApiV1();

  const [bankDetails, setBankDetails] = useState<BankAccount[]>();

  useEffect(() => {
    getBankDetails().then((bankAccounts) => {
      setBankDetails(bankAccounts);
    });
  }, []);

  const BankAccountList = ({ bankAccounts }: { bankAccounts: BankAccount[] }) => {
    return (
      <div className="bank-account-table gap-2 flex flex-column p-2 pt-0">
        {(bankAccounts.length || 0) > 0 && (
          <table>
            <thead>
              <tr>
                <th className="text-left m-2 p-2">
                  <Typography type={'text-md'}>Institution Name</Typography>
                </th>
                <th className="text-center m-2 p-2">
                  <Typography type={'text-md'}>Routing Number</Typography>
                </th>
                <th className="text-center m-2 p-2">
                  <Typography type={'text-md'}>Account</Typography>
                </th>
                <th className="text-left m-2 p-2">
                  <Typography type={'text-md'}>Account Status</Typography>
                </th>
              </tr>
            </thead>
            <tbody>
              {bankAccounts.map((account) => {
                return (
                  <tr key={account.id}>
                    <td className="text-left">{account.bank_name}</td>
                    <td className="text-center">{account.routing_number}</td>
                    <td className="text-center">{account.last4}</td>
                    <td className="text-left">{account.status}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    );
  };

  return (
    <div className="flex flex-column gap-4">
      <h2>Payout Bank Details</h2>
      <div className="flex justify-between">
        <Card>{bankDetails && <BankAccountList bankAccounts={bankDetails}></BankAccountList>}</Card>
      </div>
    </div>
  );
};
